import type { AuthMembership } from '@services/auth.service';

export function hasActiveTenant(activeCompanyId: string | null | undefined): boolean {
  return !!activeCompanyId && activeCompanyId.length > 0;
}

export function getActiveMembership(
  memberships: AuthMembership[],
  activeCompanyId: string | null | undefined,
): AuthMembership | undefined {
  if (!activeCompanyId) return undefined;
  return memberships.find((m) => m.companyId === activeCompanyId);
}

export function getActiveCompanyName(
  memberships: AuthMembership[],
  activeCompanyId: string | null | undefined,
): string | null {
  return getActiveMembership(memberships, activeCompanyId)?.companyName ?? null;
}

export function canAccessTenantRoutes(
  activeCompanyId: string | null | undefined,
  memberships: AuthMembership[],
  demoEnabled: boolean,
): boolean {
  if (demoEnabled) return true;
  if (hasActiveTenant(activeCompanyId)) return true;
  return memberships.length > 0 && hasActiveTenant(activeCompanyId);
}

export function needsCompanySetup(
  activeCompanyId: string | null | undefined,
  memberships: AuthMembership[],
  demoEnabled: boolean,
): boolean {
  if (demoEnabled) return false;
  return !hasActiveTenant(activeCompanyId) && memberships.length === 0;
}
